export default "/kiban/_next/static/images/editVariantSlit-52a8280202277b19620c595a0ee3846d.png";